import { LoadingStatusType, PeakPayrollExceptionCode, RevenueDeductType, TypeComponentNoti } from "@/enums/enums";
import { GetErrorMessageByPayrollExceptionCode } from "@/helper/exceptionCodeHelper";
import {
  ConvertToRevenueDeductCreate,
  ConvertToRevenueDeductEdit,
  SetHeaderRevenueDeductTable,
  SetTableRevenueDeductList,
  SetTapsRevenueDeductTable,
  UpdateRevenueDeductNameLocale,
  ValidateCreateRevenueDeduct,
} from "@/helper/revenueDeductHelper";
import { i18n } from "@/i18n";
import { RevenueDeductModel } from "@/model/revenueDeduct/revenueDeductModel";
import API from "@/service/Index";
import { ConvertToRevenueDeductList } from "@/service/revenueDeduct/revenueDeductFacade";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({ namespaced: true })
export default class RevenueDeduct extends VuexModule {
  public createOrUpdateRevenueDeductLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public revenueDeductList: Array<RevenueDeductModel> = [];
  public revenueDeductLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public revenueDeductTableLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public revenueDeductTableList: any = [];
  public headerRevenueDeductTable: any = [];
  public tapsRevenueDeductTable: any = [];
  public revenueDeductSuggestionCodeLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public revenueDeductSuggestionCode = "";

  get getCreateOrUpdateRevenueDeductLoadingStatus(): LoadingStatusType {
    return this.createOrUpdateRevenueDeductLoadingStatus;
  }
  get getRevenueDeductList(): Array<RevenueDeductModel> {
    return this.revenueDeductList;
  }
  get getRevenueDeductLoadingStatus(): LoadingStatusType {
    return this.revenueDeductLoadingStatus;
  }
  get getRevenueDeductTableLoadingStatus(): LoadingStatusType {
    return this.revenueDeductTableLoadingStatus;
  }
  get getRevenueDeductTableList(): any {
    return this.revenueDeductTableList;
  }
  get getHeaderRevenueDeductTable(): any {
    return this.headerRevenueDeductTable;
  }
  get getTapsRevenueDeductTable(): any {
    return this.tapsRevenueDeductTable;
  }
  get getRevenueDeductSuggestionCodeLoadingStatus(): LoadingStatusType {
    return this.revenueDeductSuggestionCodeLoadingStatus;
  }
  get getRevenueDeductSuggestionCode(): string {
    return this.revenueDeductSuggestionCode;
  }
  @Mutation
  public MutationCreateRevenueDeduct(result: any) {}

  @Mutation
  public MutationUpdateRevenueDeduct(result: any) {}

  @Mutation
  public MutationRevenueDeductList(revenueDeductList: Array<RevenueDeductModel>) {
    this.revenueDeductList = revenueDeductList;
  }
  @Mutation
  public MutationRevenueDeductTable(tableViewModel: any) {
    UpdateRevenueDeductNameLocale(this.revenueDeductList, i18n.locale);
    const table = SetTableRevenueDeductList(tableViewModel, this.revenueDeductList);
    this.tapsRevenueDeductTable = SetTapsRevenueDeductTable(tableViewModel, table.count);
    this.headerRevenueDeductTable = SetHeaderRevenueDeductTable(tableViewModel);
    this.revenueDeductTableList = table.tableList;
  }
  @Mutation
  public MutationUpdateRevenueDeductList(revenueDeductDetail: any) {
    const revenueDeductUpdate = this.revenueDeductList.find((x) => x.id == revenueDeductDetail.id);
    if (revenueDeductUpdate) {
      revenueDeductUpdate.isArchived = revenueDeductDetail.isArchived;
    }
  }

  @Mutation
  public MutationRevenueDeductLoadingStatus(status: LoadingStatusType) {
    this.revenueDeductLoadingStatus = status;
  }

  @Mutation
  public MutationCreateOrUpdateRevenueDeductLoadingStatus(status: LoadingStatusType) {
    this.createOrUpdateRevenueDeductLoadingStatus = status;
  }

  @Mutation
  public MutationUpdateRevenueDeductDeleted(result: any) {
    console.log(result);
  }
  @Mutation
  public MutationSetRevenueDeductTableLoadingStatus(loadingStatus: LoadingStatusType) {
    this.revenueDeductTableLoadingStatus = loadingStatus;
  }
  @Mutation
  public MutationSetRevenueDeductSuggestionCodeLoadingStatus(loadingStatus: LoadingStatusType) {
    this.revenueDeductSuggestionCodeLoadingStatus = loadingStatus;
  }
  @Mutation
  public MutationRevenueDeductSuggestionCode(code: string) {
    this.revenueDeductSuggestionCode = code;
  }
  @Action
  public DoGetRevenueDeductList() {
    if (this.revenueDeductLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationRevenueDeductLoadingStatus", LoadingStatusType.Loading);
      API.RevenueDeductService.DoGetRevenueDeductList().then((resRevenueDeductList) => {
        if (resRevenueDeductList.status.IsSuccess()) {
          const revenueDeductList = ConvertToRevenueDeductList(resRevenueDeductList.data.revenueDeductList);
          this.context.commit("MutationRevenueDeductList", revenueDeductList);
        }

        this.context.commit("MutationRevenueDeductLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoGetRevenueDeductTableList(revenueDeductTableViewModel: any) {
    if (this.revenueDeductLoadingStatus == LoadingStatusType.Success) {
      this.context.commit("MutationRevenueDeductTable", revenueDeductTableViewModel);
    } else if (this.revenueDeductLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationRevenueDeductLoadingStatus", LoadingStatusType.Loading);
      API.RevenueDeductService.DoGetRevenueDeductList().then((resRevenueDeductList) => {
        const revenueDeductList = ConvertToRevenueDeductList(resRevenueDeductList.data.revenueDeductList);
        this.context.commit("MutationRevenueDeductList", revenueDeductList);
        this.context.commit("MutationRevenueDeductTable", revenueDeductTableViewModel);
        this.context.commit("MutationRevenueDeductLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoCreateRevenueDeduct(createRevenueDeductTemplate: any) {
    if (this.createOrUpdateRevenueDeductLoadingStatus !== LoadingStatusType.Loading) {
      const validateCreateRevenueDeductTemplate = ValidateCreateRevenueDeduct(createRevenueDeductTemplate);
      const inputAlert: any = {
        alertMessage: "",
        typeMessage: TypeComponentNoti.Success,
      };
      if (validateCreateRevenueDeductTemplate) {
        this.context.commit("MutationCreateOrUpdateRevenueDeductLoadingStatus", LoadingStatusType.Loading);
        const revenueDeductModal: RevenueDeductModel = ConvertToRevenueDeductCreate(createRevenueDeductTemplate);

        API.RevenueDeductService.DoCreateRevenueDeduct(revenueDeductModal).then((resCreateRevenueDeduct) => {
          if (resCreateRevenueDeduct.data.responseCode.IsSuccess()) {
            this.context.commit("MutationCreateRevenueDeduct", resCreateRevenueDeduct);
            inputAlert.alertMessage = i18n.t("Create_Message_Success", {
              message:
                (revenueDeductModal.revenueDeductType == RevenueDeductType.Revenue
                  ? i18n.t("Revenue")
                  : i18n.t("Deduct")) +
                " #" +
                revenueDeductModal.code +
                " " +
                (i18n.locale == "en" ? revenueDeductModal.nameEn : revenueDeductModal.nameTh),
            });
            inputAlert.typeMessage = TypeComponentNoti.Success;
            this.context.commit("MutationCreateOrUpdateRevenueDeductLoadingStatus", LoadingStatusType.Success);
          } else if (resCreateRevenueDeduct.data.exception.code == PeakPayrollExceptionCode.CodeDuplicated) {
            createRevenueDeductTemplate.code.validateError = true;
            inputAlert.alertMessage = i18n.t("Exceptions_Notification.CodeDuplicated", {
              text:
                revenueDeductModal.revenueDeductType == RevenueDeductType.Revenue
                  ? i18n.t("Revenue")
                  : i18n.t("Deduct"),
            });
            inputAlert.typeMessage = TypeComponentNoti.Error;
            this.context.commit("MutationCreateOrUpdateRevenueDeductLoadingStatus", LoadingStatusType.None);
          } else {
            createRevenueDeductTemplate.code.validateError = true;
            inputAlert.alertMessage = GetErrorMessageByPayrollExceptionCode(resCreateRevenueDeduct.data.exception);
            inputAlert.typeMessage = TypeComponentNoti.Error;
            this.context.commit("MutationCreateOrUpdateRevenueDeductLoadingStatus", LoadingStatusType.None);
          }
          this.context.commit("MutationRevenueDeductLoadingStatus", LoadingStatusType.None);
          this.context.dispatch("Alert/SetAlertMessage", inputAlert, { root: true });
        });
      } else {
        inputAlert.alertMessage = i18n.t("Please_Fill_In_Valid_Value");
        inputAlert.typeMessage = TypeComponentNoti.Error;
      }
      this.context.dispatch("Alert/SetAlertMessage", inputAlert, { root: true });
    }
  }

  @Action
  public DoUpdateRevenueDeduct(createRevenueDeductTemplate: any) {
    if (this.createOrUpdateRevenueDeductLoadingStatus !== LoadingStatusType.Loading) {
      const validateCreateRevenueDeductTemplate = true;
      const inputAlert: any = {
        alertMessage: "",
        typeMessage: TypeComponentNoti.Success,
      };
      if (validateCreateRevenueDeductTemplate) {
        this.context.commit("MutationCreateOrUpdateRevenueDeductLoadingStatus", LoadingStatusType.Loading);
        const revenueDeductModal: RevenueDeductModel = ConvertToRevenueDeductEdit(createRevenueDeductTemplate);

        API.RevenueDeductService.DoUpdateRevenueDeduct(revenueDeductModal).then((resUpdateRevenueDeduct) => {
          if (resUpdateRevenueDeduct.data.responseCode.IsSuccess()) {
            this.context.commit("MutationUpdateRevenueDeduct", resUpdateRevenueDeduct);
            inputAlert.alertMessage = i18n.t("Update_Message_Success", {
              message:
                (revenueDeductModal.revenueDeductType == RevenueDeductType.Revenue
                  ? i18n.t("Revenue")
                  : i18n.t("Deduct")) +
                " #" +
                revenueDeductModal.code +
                " " +
                (i18n.locale == "en" ? revenueDeductModal.nameEn : revenueDeductModal.nameTh),
            });
            inputAlert.typeMessage = TypeComponentNoti.Success;
            this.context.commit("MutationCreateOrUpdateRevenueDeductLoadingStatus", LoadingStatusType.Success);
          } else {
            inputAlert.alertMessage = GetErrorMessageByPayrollExceptionCode(resUpdateRevenueDeduct.data.exception);
            inputAlert.typeMessage = TypeComponentNoti.Error;
            this.context.commit("MutationCreateOrUpdateRevenueDeductLoadingStatus", LoadingStatusType.None);
          }

          this.context.commit("MutationRevenueDeductLoadingStatus", LoadingStatusType.None);
          this.context.dispatch("Alert/SetAlertMessage", inputAlert, { root: true });
        });
      } else {
        inputAlert.alertMessage = i18n.t("Please_Fill_In_Valid_Value");
        inputAlert.typeMessage = TypeComponentNoti.Error;
      }
      this.context.dispatch("Alert/SetAlertMessage", inputAlert, { root: true });
    }
  }

  @Action
  public DoUpdateRevenueDeductDeleted(revenueDeductDetail: any) {
    if (this.createOrUpdateRevenueDeductLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationCreateOrUpdateRevenueDeductLoadingStatus", LoadingStatusType.Loading);

      API.RevenueDeductService.DoUpdateRevenueDeductDeleted(revenueDeductDetail.id).then(
        (resUpdateRevenueDeductDeleted) => {
          const inputAlert: any = {
            alertMessage: "",
            typeMessage: TypeComponentNoti.Success,
          };
          if (resUpdateRevenueDeductDeleted.status.IsSuccess()) {
            this.context.commit("MutationUpdateRevenueDeductDeleted", resUpdateRevenueDeductDeleted);
            inputAlert.alertMessage = i18n.t("Remove_Message_Success", {
              message:
                (revenueDeductDetail.revenueDeductType == RevenueDeductType.Revenue
                  ? i18n.t("Revenue")
                  : i18n.t("Deduct")) +
                " #" +
                revenueDeductDetail.code +
                " " +
                (i18n.locale == "en" ? revenueDeductDetail.nameEn : revenueDeductDetail.nameTh),
            });
          } else {
            inputAlert.alertMessage = GetErrorMessageByPayrollExceptionCode(
              resUpdateRevenueDeductDeleted.data.exception
            );
            inputAlert.typeMessage = TypeComponentNoti.Error;
          }

          this.context.commit("MutationCreateOrUpdateRevenueDeductLoadingStatus", LoadingStatusType.Success);

          this.context.dispatch("Alert/SetAlertMessage", inputAlert, { root: true });
        }
      );
    }
  }

  @Action
  public DoUpdateRevenueDeductArchived(revenueDeductDetail: any) {
    if (this.createOrUpdateRevenueDeductLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationCreateOrUpdateRevenueDeductLoadingStatus", LoadingStatusType.Loading);

      API.RevenueDeductService.DoUpdateRevenueDeductArchived(revenueDeductDetail).then(
        (resUpdateRevenueDeductArchived) => {
          const inputAlert: any = {
            alertMessage: "",
            typeMessage: TypeComponentNoti.Success,
          };
          if (resUpdateRevenueDeductArchived.status.IsSuccess()) {
            const revenueDeductWorlding =
              revenueDeductDetail.revenueDeductType == RevenueDeductType.Revenue ? i18n.t("Revenue") : i18n.t("Deduct");
            inputAlert.alertMessage = revenueDeductDetail.isArchived
              ? i18n.t("Off_Message_Success", {
                  message:
                    revenueDeductWorlding +
                    " #" +
                    revenueDeductDetail.code +
                    " " +
                    (i18n.locale == "en" ? revenueDeductDetail.nameEn : revenueDeductDetail.nameTh),
                })
              : i18n.t("On_Message_Success", {
                  message:
                    revenueDeductWorlding +
                    " #" +
                    revenueDeductDetail.code +
                    " " +
                    (i18n.locale == "en" ? revenueDeductDetail.nameEn : revenueDeductDetail.nameTh),
                });
            this.context.commit("MutationUpdateRevenueDeductList", revenueDeductDetail);
            this.context.commit("MutationCreateOrUpdateRevenueDeductLoadingStatus", LoadingStatusType.None);
            this.context.commit("MutationRevenueDeductLoadingStatus", LoadingStatusType.None);
          } else {
            inputAlert.alertMessage = revenueDeductDetail.isArchived ? i18n.t("Off_Failed") : i18n.t("On_Failed");
            inputAlert.typeMessage = TypeComponentNoti.Error;
            this.context.commit("MutationCreateOrUpdateRevenueDeductLoadingStatus", LoadingStatusType.Fail);
          }
          this.context.dispatch("Alert/SetAlertMessage", inputAlert, { root: true });
        }
      );
    }
  }
  @Action
  public DoSetRevenueDeductTableLoadingStatus(loadingStatus: LoadingStatusType) {
    this.context.commit("MutationSetRevenueDeductTableLoadingStatus", loadingStatus);
  }
  @Action
  public DoGetRevenueDeductSuggestionCode(departmentId: number) {
    if (this.revenueDeductSuggestionCodeLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetRevenueDeductSuggestionCodeLoadingStatus", LoadingStatusType.Loading);
      API.RevenueDeductService.DoGetRevenueDeductSuggestionCode(departmentId).then((resRevenueDeductSuggestionCode) => {
        if (resRevenueDeductSuggestionCode.status.IsSuccess()) {
          this.context.commit("MutationRevenueDeductSuggestionCode", resRevenueDeductSuggestionCode.data.code);
        }

        this.context.commit("MutationSetRevenueDeductSuggestionCodeLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
}
